<template>
      <!-- ======= SectionTwo Begins here =======  :pagination="{clickable: true}"-->
  <section id="services" class="services sectiontwo" data-aos="fade-up">
    <div class="container sectioncontrol" data-aos="fade-up">
      <div class="sectiontwopurpose">{{ cvdesc }}</div>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        <div class="col sectiontwocol8"  v-for="photo in valuesphotos" :key="photo">
          <div class="card w-100 h-100 servicescards">
            <router-link :to="{path: cvlink}" class="cardref">
            <img :src="`${myPicUrl}${photo.cardimage}`" class="card-img-top iconsize" alt="" data-aos="fade-up" data-aos-duration="100" data-aos-delay="100">
            <div class="card-body" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
              <h5 class="card-title" v-html="photo.carddesc"></h5>
              <p class="card-text"></p>
            </div>
          </router-link>
          </div>
        </div>
      </div>
      <div class="sectiontwolinkname"><a :href="cvlink">{{cvpurposevaluelinkname}}</a></div>
    </div>
  </section><!-- End Services Section -->
</template>

<script>
require('@/globalDeclare.js');
export default {
    props: ['cvdesc', 'valuesphotos', 'cvpurposevaluelinkname', 'cvlink'],
data() {
  return {
    myPicUrl: ''
  }
},
 
mounted() {
  this.myPicUrl = myUrlPath
}
}
</script>

<style scoped>
.sectioncontrol{
  opacity: .9;
  padding-top: 100px;
  padding-bottom: 100px;
  height: auto;
}
.sectiontwolinkname {
  text-align: right; 
  padding-top: 50px;
  height: 50px;
  font-size: 19px;
  background: -webkit-linear-gradient(#003, maroon);
  -webkit-background-clip: text;

  font-weight: bold;
}
.sectiontwopurpose{
  text-align: center; 
  margin-bottom: 30px; 
  height: 50px;
  font-size: 26px;
  background: -webkit-linear-gradient(#003, maroon);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.sectiontwo {
  margin-bottom: 100px;
  background-color: #f9ebea;
  
 }
.servicescards {
  background-color: #003;
  color: white;
  text-align: center;
}
.iconsize {
  width: 100px;
}
.card-title{
  color: white;
  text-decoration: none;
}
.cardref{
  text-decoration: none;
  cursor: default;
}

@media (min-width: 390px) and (max-width: 550px) {
  .sectioncontrol{
    width: 90%;
    padding-right: 20px;
  }
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .sectiontwo {
    margin-bottom: 100px;
    background-color: #f9ebea;
    margin-top: -20px;
   }
   .sectiontwopurpose{
    margin-top: -30px;
   }
   .card-title{
    width: 100%;

   }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  
 }
 
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 800px) {
 
  }

 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
    
 } 
</style>